import React from "react";
import { Card, CardBody, Table } from "reactstrap";
import "./SkeletonLoader.css";

/**
 * SkeletonListaSolicitudes - Skeleton loader para el listado de solicitudes
 * 
 * Muestra una tabla con filas skeleton mientras se cargan las solicitudes
 * Incluye columnas para: Identificador, Titular, Tipo, Estatus, Fecha, Progreso
 */
const SkeletonListaSolicitudes = ({ rows = 10 }) => {
  return (
    <Card>
      <CardBody>
        {/* Header con filtros skeleton */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex gap-2">
            {/* Skeleton para búsqueda */}
            <div className="skeleton skeleton-input" style={{ width: "250px", height: "38px" }}></div>
            
            {/* Skeleton para filtro de tipo */}
            <div className="skeleton skeleton-input" style={{ width: "150px", height: "38px" }}></div>
            
            {/* Skeleton para filtro de estatus */}
            <div className="skeleton skeleton-input" style={{ width: "150px", height: "38px" }}></div>
          </div>
          
          {/* Skeleton para botón de nueva solicitud */}
          <div className="skeleton skeleton-button" style={{ width: "150px", height: "38px" }}></div>
        </div>

        {/* Tabla skeleton */}
        <div className="table-responsive">
          <Table className="table-hover table-striped align-middle table-nowrap mb-0">
            <thead className="table-light">
              <tr>
                <th style={{ width: "120px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "100px" }}></div>
                </th>
                <th style={{ width: "200px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "80px" }}></div>
                </th>
                <th style={{ width: "100px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "60px" }}></div>
                </th>
                <th style={{ width: "150px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "70px" }}></div>
                </th>
                <th style={{ width: "120px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "80px" }}></div>
                </th>
                <th style={{ width: "150px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "90px" }}></div>
                </th>
                <th style={{ width: "80px" }}>
                  <div className="skeleton skeleton-text" style={{ width: "70px" }}></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }).map((_, index) => (
                <tr key={index}>
                  {/* Identificador */}
                  <td>
                    <div className="skeleton skeleton-text" style={{ width: "100px" }}></div>
                  </td>
                  
                  {/* Titular */}
                  <td>
                    <div className="skeleton skeleton-text mb-1" style={{ width: "180px" }}></div>
                    <div className="skeleton skeleton-text" style={{ width: "120px", height: "12px" }}></div>
                  </td>
                  
                  {/* Tipo */}
                  <td>
                    <div className="skeleton skeleton-badge" style={{ width: "70px" }}></div>
                  </td>
                  
                  {/* Estatus */}
                  <td>
                    <div className="skeleton skeleton-badge" style={{ width: "110px" }}></div>
                  </td>
                  
                  {/* Fecha */}
                  <td>
                    <div className="skeleton skeleton-text" style={{ width: "90px" }}></div>
                  </td>
                  
                  {/* Progreso */}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="skeleton skeleton-progress" style={{ width: "80px", height: "8px" }}></div>
                      <div className="skeleton skeleton-text" style={{ width: "35px", height: "14px" }}></div>
                    </div>
                  </td>
                  
                  {/* Acciones */}
                  <td>
                    <div className="skeleton skeleton-button" style={{ width: "60px", height: "32px" }}></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Footer con paginación skeleton */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div className="skeleton skeleton-text" style={{ width: "150px", height: "16px" }}></div>
          <div className="d-flex gap-2">
            <div className="skeleton skeleton-button" style={{ width: "80px", height: "32px" }}></div>
            <div className="skeleton skeleton-button" style={{ width: "80px", height: "32px" }}></div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default SkeletonListaSolicitudes;
